define("shared/components/shared/ui/search-box/results", ["exports", "@ember/component", "@ember/template-factory"], function (_exports, _component, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-classic-decorator",0,"@ember/component",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class={{concat "tSC--drop " @additionalClasses}}>
    <div class="tSC--dropBody">
      <ul class="tSC--dropBody__list">
        {{#each @searchResults as |result|}}
          <Shared::Ui::SearchBox::Result
            class="qa--categorize_search_box_result_item"
            @result={{result}}
            @onSelectAction={{action @onSelectAction}}
          />
        {{else}}
          <Shared::Ui::SearchBox::ResultBlank
            class="qa--categorize_search_box_result_blank_item"
            @message={{t "profile_categorization.search.no_results_found"}}
          />
        {{/each}}
      </ul>
    </div>
  </div>
  
  */
  {
    "id": "H8AuFOJ6",
    "block": "[[[10,0],[15,0,[28,[37,0],[\"tSC--drop \",[30,1]],null]],[12],[1,\"\\n  \"],[10,0],[14,0,\"tSC--dropBody\"],[12],[1,\"\\n    \"],[10,\"ul\"],[14,0,\"tSC--dropBody__list\"],[12],[1,\"\\n\"],[42,[28,[37,2],[[28,[37,2],[[30,2]],null]],null],null,[[[1,\"        \"],[8,[39,3],[[24,0,\"qa--categorize_search_box_result_item\"]],[[\"@result\",\"@onSelectAction\"],[[30,3],[28,[37,4],[[30,0],[30,4]],null]]],null],[1,\"\\n\"]],[3]],[[[1,\"        \"],[8,[39,5],[[24,0,\"qa--categorize_search_box_result_blank_item\"]],[[\"@message\"],[[28,[37,6],[\"profile_categorization.search.no_results_found\"],null]]],null],[1,\"\\n\"]],[]]],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"]],[\"@additionalClasses\",\"@searchResults\",\"result\",\"@onSelectAction\"],false,[\"concat\",\"each\",\"-track-array\",\"shared/ui/search-box/result\",\"action\",\"shared/ui/search-box/result-blank\",\"t\"]]",
    "moduleName": "shared/components/shared/ui/search-box/results.hbs",
    "isStrictMode": false
  });

  class Results extends _component.default {}

  _exports.default = Results;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, Results);
});